import React from 'react';
import { attendanceHistoryText } from '../../../domain/lessonAttendance';
import s from './attendance.module.css';

// What has happened to this lesson's attendance record: one line, since the
// record stores only who last touched it, not a log.
//
// `updatedBy` is tested first (#200): `updatedAt` is a `serverTimestamp()`,
// which reads back null from the writing device's own cache until the server
// acknowledges the write (both client SDKs default `ServerTimestampBehavior` to
// `none`), so testing it would tell a teacher who marked attendance offline
// that nothing was recorded. `updatedBy` is a plain string written in the same
// object. `updatedAt` stays in the condition for a record written before
// `updatedBy` existed. `test/ui/historyTab.test.jsx` covers the offline shape
// (`updatedBy` set, `updatedAt` null).
//
// The uid is compared, never printed (#202): `useAttendance.jsx` writes
// `updatedBy: user.uid`, and `viewerUid` is the signed-in uid. Every document
// lives under `users/{uid}` and `isOwner(uid)` in firestore.rules admits only
// that account, so the writer is the reader, but the comparison is made
// rather than assumed. With `viewerUid` unknown it names no writer and says
// only that the record changed.
//
// The line is `attendanceHistoryText` in src/domain/lessonAttendance.js, so a
// phone's History says the same.
export default function HistoryTab({ record, viewerUid = null }) {
  return <div className={s.history}>{attendanceHistoryText(record, viewerUid)}</div>;
}
